import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Box } from '@material-ui/core';

export default () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100vh',
      backgroundColor: '#fff',
      color: '#505661',
      position: 'relative',
    }}
  >
    <CircularProgress
      color="inherit"
      size={40}
      style={{
        position: 'absolute', top: '50%', left: '50%', height: '40px', width: '40px'
      }}
    />
  </Box>
);
